import { render, staticRenderFns } from "./berth-keyboard.vue?vue&type=template&id=3e453bee&scoped=true"
import script from "./berth-keyboard.vue?vue&type=script&lang=js"
export * from "./berth-keyboard.vue?vue&type=script&lang=js"
import style0 from "./berth-keyboard.vue?vue&type=style&index=0&id=3e453bee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e453bee",
  null
  
)

export default component.exports